// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"132":"forms","138":"profile","225":"rooms","796":"tables","854":"widgets","966":"login"}[chunkId] || chunkId) + "." + {"132":"5a8ece24","138":"3355cfb1","225":"3e007060","631":"c30b1259","796":"3dfcdaf9","854":"4319a011","966":"54570546"}[chunkId] + ".js";
};